var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useEffect, useState } from "react";
import Button from "../../../button/Button";
import { IoMdHeart, IoMdHeartEmpty } from "react-icons/io";
import Icon from "../../../icon/Icon";
export function FavoriteButton(_a) {
    var _this = this;
    var productId = _a.productId, iconOnly = _a.iconOnly, _b = _a.defaultSelected, defaultSelected = _b === void 0 ? false : _b, addProduct = _a.addProduct, removeProduct = _a.removeProduct, rest = __rest(_a, ["productId", "iconOnly", "defaultSelected", "addProduct", "removeProduct"]);
    var _c = useState(false), isLoading = _c[0], setLoading = _c[1];
    var _d = useState(defaultSelected), isSelected = _d[0], setSelected = _d[1];
    var _e = useState(null), annoucement = _e[0], setAnnoucment = _e[1];
    useEffect(function () {
        setSelected(defaultSelected);
        setLoading(false);
    }, [defaultSelected]);
    var btnLabel = "".concat(isSelected ? "Remove from" : "Add to", " favorites");
    var add = useCallback(function (productId) { return __awaiter(_this, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSelected(true);
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4, addProduct(productId)];
                case 2:
                    _a.sent();
                    setAnnoucment("Product added to favorites");
                    return [3, 5];
                case 3:
                    err_1 = _a.sent();
                    setSelected(false);
                    err_1 && console.log(err_1);
                    return [3, 5];
                case 4:
                    setLoading(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); }, [addProduct]);
    var remove = useCallback(function (productId) { return __awaiter(_this, void 0, void 0, function () {
        var err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSelected(false);
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4, removeProduct(productId)];
                case 2:
                    _a.sent();
                    setAnnoucment("Product removed from favorites");
                    return [3, 5];
                case 3:
                    err_2 = _a.sent();
                    setSelected(true);
                    err_2 && console.log(err_2);
                    return [3, 5];
                case 4:
                    setLoading(false);
                    return [7];
                case 5: return [2];
            }
        });
    }); }, [removeProduct]);
    var handleClick = useCallback(function () {
        if (isLoading)
            return;
        isSelected ? remove(productId) : add(productId);
    }, [productId, isSelected, isLoading, add, remove]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { role: "alert", className: "sr-only" },
            React.createElement("p", null, annoucement)),
        React.createElement(Button, __assign({ fill: "text", width: 1, onClick: handleClick }, rest),
            iconOnly && React.createElement("span", { className: "sr-only" }, btnLabel),
            React.createElement(Icon, { color: isSelected ? "gameRed" : "black", icon: isSelected ? IoMdHeart : IoMdHeartEmpty, "aria-hidden": "true", mr: iconOnly ? 0 : 1, title: "Heart Icon" }),
            !iconOnly && btnLabel)));
}
export default FavoriteButton;
//# sourceMappingURL=FavoriteButton.js.map